/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {JournalTaskRunPoint} from './JournalTaskRunPoint';
import {
  JournalTaskRunPointFromJSON,
  JournalTaskRunPointFromJSONTyped,
  JournalTaskRunPointToJSON
} from './JournalTaskRunPoint';
import type {JournalLog} from './JournalLog';
import {JournalLogFromJSON, JournalLogFromJSONTyped, JournalLogToJSON} from './JournalLog';
import type {LastRunStatus} from './LastRunStatus';
import {
  LastRunStatusFromJSON,
  LastRunStatusFromJSONTyped,
  LastRunStatusToJSON
} from './LastRunStatus';
import type {CalculationErrorInfo} from './CalculationErrorInfo';
import {
  CalculationErrorInfoFromJSON,
  CalculationErrorInfoFromJSONTyped,
  CalculationErrorInfoToJSON
} from './CalculationErrorInfo';
import type {CalculationStatusEnum} from './CalculationStatusEnum';
import {
  CalculationStatusEnumFromJSON,
  CalculationStatusEnumFromJSONTyped,
  CalculationStatusEnumToJSON
} from './CalculationStatusEnum';
import type {CheckpointOut} from './CheckpointOut';
import {
  CheckpointOutFromJSON,
  CheckpointOutFromJSONTyped,
  CheckpointOutToJSON
} from './CheckpointOut';

/**
 *
 * @export
 * @interface ResponseCheckpointsSubscribe
 */
export interface ResponseCheckpointsSubscribe {
  /**
   *
   * @type {string}
   * @memberof ResponseCheckpointsSubscribe
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof ResponseCheckpointsSubscribe
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof ResponseCheckpointsSubscribe
   */
  lastSavingDt: Date;
  /**
   *
   * @type {CalculationStatusEnum}
   * @memberof ResponseCheckpointsSubscribe
   */
  calcStatus?: CalculationStatusEnum;
  /**
   *
   * @type {Date}
   * @memberof ResponseCheckpointsSubscribe
   */
  runAt: Date;
  /**
   *
   * @type {number}
   * @memberof ResponseCheckpointsSubscribe
   */
  calculationNumber: number;
  /**
   *
   * @type {CalculationStatusEnum}
   * @memberof ResponseCheckpointsSubscribe
   */
  status: CalculationStatusEnum;
  /**
   *
   * @type {Array<JournalLog>}
   * @memberof ResponseCheckpointsSubscribe
   */
  items: Array<JournalLog>;
  /**
   *
   * @type {boolean}
   * @memberof ResponseCheckpointsSubscribe
   */
  readonly isWarning: boolean;
  /**
   *
   * @type {number}
   * @memberof ResponseCheckpointsSubscribe
   */
  number: number;
  /**
   *
   * @type {Array<CalculationErrorInfo>}
   * @memberof ResponseCheckpointsSubscribe
   */
  errorInfo: Array<CalculationErrorInfo>;
}

/**
 * Check if a given object implements the ResponseCheckpointsSubscribe interface.
 */
export function instanceOfResponseCheckpointsSubscribe(
  value: object
): value is ResponseCheckpointsSubscribe {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('lastSavingDt' in value) || value['lastSavingDt'] === undefined) return false;
  if (!('runAt' in value) || value['runAt'] === undefined) return false;
  if (!('calculationNumber' in value) || value['calculationNumber'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('items' in value) || value['items'] === undefined) return false;
  if (!('isWarning' in value) || value['isWarning'] === undefined) return false;
  if (!('number' in value) || value['number'] === undefined) return false;
  if (!('errorInfo' in value) || value['errorInfo'] === undefined) return false;
  return true;
}

export function ResponseCheckpointsSubscribeFromJSON(json: any): ResponseCheckpointsSubscribe {
  return ResponseCheckpointsSubscribeFromJSONTyped(json, false);
}

export function ResponseCheckpointsSubscribeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseCheckpointsSubscribe {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    lastSavingDt: new Date(json['last_saving_dt']),
    calcStatus:
      json['calc_status'] == null ? undefined : CalculationStatusEnumFromJSON(json['calc_status']),
    runAt: new Date(json['run_at']),
    calculationNumber: json['calculation_number'],
    status: CalculationStatusEnumFromJSON(json['status']),
    items: (json['items'] as Array<any>).map(JournalLogFromJSON),
    isWarning: json['is_warning'],
    number: json['number'],
    errorInfo: (json['error_info'] as Array<any>).map(CalculationErrorInfoFromJSON)
  };
}

export function ResponseCheckpointsSubscribeToJSON(
  value?: Omit<ResponseCheckpointsSubscribe, 'is_warning'> | null
): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    last_saving_dt: value['lastSavingDt'].toISOString(),
    calc_status: CalculationStatusEnumToJSON(value['calcStatus']),
    run_at: value['runAt'].toISOString(),
    calculation_number: value['calculationNumber'],
    status: CalculationStatusEnumToJSON(value['status']),
    items: (value['items'] as Array<any>).map(JournalLogToJSON),
    number: value['number'],
    error_info: (value['errorInfo'] as Array<any>).map(CalculationErrorInfoToJSON)
  };
}
